import {useContext} from "react";
import {RegistrationsContext} from "../../../context/contextProvider";

/**
 * Hook to refresh registrations and devices
 */
export function useRefreshData() {
  const { registrations } = useContext(RegistrationsContext);
  const { fetchAllRegistrations, fetchAllCompletedRegistrationsMetaData } = registrations;
  const { devices } = useContext(RegistrationsContext);
  const { fetchDevices } = devices;
  
  return async () => {
    fetchAllRegistrations();
    fetchAllCompletedRegistrationsMetaData();
    fetchDevices();
  };
}